import {
    LOGGED,
    NOT_LOGGED_IN,
} from '../actions/user'

const initialTestState = {
    userData: null,
    status: null,
}

export default ( state = initialTestState, action ) =>  {
    switch (action.type) {
        case LOGGED: {
            return {
                userData: action.payload,
                status: 'done'
            }
        }
        case NOT_LOGGED_IN: {
            return {
                userData: null,
                status: 'done'
            }
        }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/user.js